import React from "react";
import Link from "next/link";
import strings from "../../strings";

const ButtonBlueBorder = ({
  placeholder,
  onClick,
  disabled = false,
  loading = false,
}) => {
  const handleClick = (e) => {
    if (!disabled && !loading && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={`w-[100%] shadow-custom-dark-bottom rounded-[10px] ${disabled || loading ? "opacity-60 pointer-events-none" : ""}`}
    >
      <div className="h-[60px] w-[100%] bg-gradient-to-b from-[#0A85C2] to-[#123597] flex justify-center items-center rounded-[10px] p-[2px]">
        <div
          className={`h-[56px] w-[100%] bg-[#E7EBF0] text-[20px] text-[#414B5A] flex justify-center items-center rounded-[8px] font-variation-customOpt20 font-semibold leading-[24px] ${!disabled && !loading ? "cursor-pointer" : ""}`}
          onClick={handleClick}
        >
          {loading ?
            <div className="flex items-center gap-2">
              <svg
                className="animate-spin h-5 w-5 text-[#414B5A]"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span>{placeholder}</span>
            </div>
          : placeholder}
        </div>
      </div>
    </div>
  );
};

export default ButtonBlueBorder;
